import React from "react";
import { SIDEBAR_CLOSE, SIDEBAR_OPEN } from "../actions";

const initialState = {
  sidebarOpen: false,
};

const SidebarContext = React.createContext();

function Sidebar_Reducer(state, action) {
  if (action.type === SIDEBAR_OPEN) {
    return { ...state, sidebarOpen: true };
  }
  if (action.type === SIDEBAR_CLOSE) {
    return { ...state, sidebarOpen: false };
  }
  throw new Error(`No Matching "${action.type}" - action type`);
}

export function SidebarProvider({ children }) {
  const [state, dispatch] = React.useReducer(Sidebar_Reducer, initialState);
  function openSidebar() {
    dispatch({ type: SIDEBAR_OPEN });
  }
  function closeSidebar() {
    dispatch({ type: SIDEBAR_CLOSE });
  }
  return (
    <SidebarContext.Provider value={{ ...state, openSidebar, closeSidebar }}>
      {children}
    </SidebarContext.Provider>
  );
}

export function useSidebarContext() {
  return React.useContext(SidebarContext);
}

export default SidebarProvider;
